import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { NotificationManager } from "react-notifications";
import { ApiClient } from "services"; 

export const UserList = () => {
    
  const apiClient = ApiClient(); 
  const [users, setUsers] = useState([]);

  useEffect(() => {

    apiClient
      .get("users") 
      .then((response) => {
        const userData = response.data.Users; 

        setUsers(userData);
      })
      .catch((error) => {
        NotificationManager.error("Error fetching user data");
      });
  }, []);

  return (
    <div>
      <h1>User List</h1>
      <Table>
        <thead>
          <tr>
            <th>UserID</th>
            <th>Email Address</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Updated Date (UTC)</th>
            <th>Is Subscriber</th>
            <th>Organisation Role</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.UserID}>
              <td>{user.UserID}</td>
              <td>{user.EmailAddress}</td>
              <td>{user.FirstName}</td>
              <td>{user.LastName}</td>
              <td>{user.UpdatedDateUTC}</td>
              <td>{user.IsSubscriber ? "Yes" : "No"}</td>
              <td>{user.OrganisationRole}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default UserList;